// extracted by mini-css-extract-plugin
module.exports = {"root":"CookiePreferenceLabel_root__S08iA","link":"CookiePreferenceLabel_link__CqyUJ","inFooter":"CookiePreferenceLabel_inFooter__vZ4v9"};